import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogModule, MatDialogRef} from '@angular/material/dialog';
import {LoadingService} from '../shared/services/loading.service';
import {NewsletterFormContent} from '../models/tenant.model';
import {NewsletterComponent} from '../newsletter/newsletter.component';
import {LoadingComponent} from '../shared/loading/loading.component';
import {MatIconModule} from '@angular/material/icon';


@Component({
    selector: 'newsletter-dialog',
    templateUrl: './newsletter-dialog.component.html',
    styleUrls: ['./newsletter-dialog.component.scss'],
    providers: [
        LoadingService
    ],
    imports: [MatIconModule, LoadingComponent, MatDialogModule, NewsletterComponent]
})
export class NewsletterDialogComponent implements OnInit {

  newsletterContent: NewsletterFormContent;

  constructor(private dialogRef: MatDialogRef<NewsletterDialogComponent>,
              @Inject(MAT_DIALOG_DATA) data) {

    this.newsletterContent = data;

  }

  ngOnInit() {

  }

  close() {
    this.dialogRef.close();
  }

}

